import { connectToWebChat, Components, hooks as bfHooks } from 'botframework-webchat-component';

import { Constants, DirectLineActivity } from 'botframework-webchat-core';
import { hooks } from 'botframework-webchat-api';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { FC, forwardRef, useCallback, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';

import { useMergedOptions } from '../selectors/useMergedOptions';
import { useContextMenu } from '../selectors/useContextMenu'
import useDruidLocalize from '../hooks/useDruidLocalize';

import useStyleToEmotionObject from 'botframework-webchat-component/lib/hooks/internal/useStyleToEmotionObject';

import DruidWebchatContext, { DruidWebchatContextType } from '../WebChatContext';
import { webChatDefaultOptions } from '../WebChatOptions';
import Dropdown from 'react-bootstrap/Dropdown';
import { ButtonProps } from 'react-bootstrap/esm/Button';
import * as bsIcons from 'react-icons/bs';
import { BsEmojiSmile } from 'react-icons/bs';

import { useWebChatRefsContext } from '../hooks/useWebChatRefsContext';
import InlineSVG from 'svg-inline-react';
import { shouldEnter_fileUploadInputMode } from '../logics/druidBusinessLogic';
import EmojiPicker, { EmojiClickData, EmojiStyle } from 'emoji-picker-react';
import { useCreateActivityRenderer, useSendBoxValue } from 'botframework-webchat-api/lib/hooks';
import { FaRegTimesCircle, FaTimesCircle } from 'react-icons/fa';

const defaultContextMenuIcon = ({ size, restylingsEnabled, expanded }: { size: any, restylingsEnabled?: boolean, expanded?: boolean }) => {
  if(restylingsEnabled) {
    size = '16px';

    if(!expanded) {
      return `<svg  width="${size || 'auto'}" height="${size || 'auto'}" viewBox="0 0 14 14" fill="currentColor">
                <path d="M13.5 7C13.5 7.5625 13.0312 8.03125 12.5 8.03125H8V12.5312C8 13.0625 7.53125 13.5 7 13.5C6.4375 13.5 6 13.0625 6 12.5312V8.03125H1.5C0.9375 8.03125 0.5 7.5625 0.5 7C0.5 6.46875 0.9375 6.03125 1.5 6.03125H6V1.53125C6 0.96875 6.4375 0.5 7 0.5C7.53125 0.5 8 0.96875 8 1.53125V6.03125H12.5C13.0312 6 13.5 6.46875 13.5 7Z"/>
             </svg>
      `;
    } else {
      return `<svg width="${size || 'auto'}" height="${size || 'auto'}" viewBox="0 0 24 24" fill="currentColor">
                 <path d="M5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L10.5858 12L4.29289 5.70709C3.90237 5.31657 3.90237 4.6834 4.29289 4.29288C4.68342 3.90235 5.31658 3.90235 5.70711 4.29288L12 10.5858L18.2929 4.29288C18.6834 3.90235 19.3166 3.90235 19.7071 4.29288C20.0976 4.6834 20.0976 5.31657 19.7071 5.70709L13.4142 12L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L12 13.4142L5.70711 19.7071Z"/>
              </svg>
      `;
    }
    
    // return `<svg stroke="currentColor" fill="currentColor" stroke-width="0"  width="${size || 'auto'}" height="${size || 'auto'}" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path></svg>`
  }

  return `<svg stroke="currentColor" fill="currentColor" stroke-width="0"  width="${size || 'auto'}" height="${size || 'auto'}" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path></svg>`
};


const { DictationInterims, MicrophoneButton, SendButton, SuggestedActions, SendTextBox, UploadButton } = Components;
const { useActivities, useDirection, useDictateState, useStyleOptions, useSendMessage, useDisabled, useLanguage, useLocalizer } = hooks;
const { useStyleSet, useWebSpeechPonyfill, useFocus, useSendBoxSpeechInterimsVisible } = bfHooks;

// const ROOT_STYLE = {
//   display: 'flex',

//   // .sr-only - This component is intended to be invisible to the visual Web Chat user, but read by the AT when using a screen reader

//   '& > .sr-only': {
//     color: 'transparent',
//     height: 1,
//     left: -10000,
//     overflow: 'hidden',
//     position: 'absolute',
//     top: 0,
//     whiteSpace: 'nowrap',
//     width: 1
//   }
// };

const {
  DictateState: { DICTATING, STARTING }
} = Constants;


const ROOT_STYLE = {
  '&.webchat__send-box': {
    '& .webchat__send-box__button': { flexShrink: 0 },
    '& .webchat__send-box__dictation-interims': { flex: 10000 },
    '& .webchat__send-box__main': { display: 'flex' },
    '& .webchat__send-box__microphone-button': { flex: 1 },
    '& .webchat__send-box__text-box': { flex: 10000 }
  }
};

// // TODO: [P3] We should consider exposing core/src/definitions and use it instead
// function activityIsSpeakingOrQueuedToSpeak(activity: DirectLineActivity) {
//   return activity.type === 'message' && activity.channelData?.speak;
// }

// function useSendBoxSpeechInterimsVisible(): [boolean] {
//   const [activities] = useActivities();
//   const [dictateState] = useDictateState();

//   return [
//     (dictateState === STARTING || dictateState === DICTATING) &&
//       !activities.filter(activityIsSpeakingOrQueuedToSpeak).length
//   ];
// }

type BasicSendBoxProps = {
  className?: string;
};
const DruidSendBox: FC<BasicSendBoxProps> = connectToWebChat()(({ className }) => {

  const [druidWebChatState, druidWebChatDispatch,] = useContext<DruidWebchatContextType>(DruidWebchatContext);

  const { sensitiveDataInputMode, fileUploadInputMode, inputBlocked, selectedActivityForReply} = druidWebChatState;
  const [{ hideSendBox, hideUploadButton, sendBoxButtonAlignment, backgroundColor, sendBoxButtonShadeColorOnDisabled, sendBoxBackground, sendBoxMaxHeight, sendBoxHeight, subtle, accent, sendBoxButtonColor, sendBoxButtonColorOnHover, sendBoxButtonShadeColor, sendBoxButtonColorOnFocus, sendBoxDisabledTextColor, sendBoxButtonColorOnDisabled, paddingRegular, fontSizeSmall }] = useStyleOptions();
  const { UI: { restylingsEnabled, druidSendBoxReplyToModeBackgroundColor, emojiPickerEnabled, buttonsTextColor, hideDruidSendBox, blockingInputDruidSendBox, showPoweredBy, hideSuggestedActions, druidSendBoxPaddingLeftRight, druidSendBoxPaddingTop, druidSendBoxPaddingBottom, druidSendBoxTextBoxPadding, druidSendBoxInnerPaddingLeftRight, druidSendBoxInnerPaddingTopBottom, druidSendBoxInnerBorderRadius, sendBoxFontSize, replyToMessageEnabled } = {}} = useMergedOptions();
  const [{ sendBox: sendBoxStyleSet }] = useStyleSet();
  const [{ sendBoxTextWrap }] = useStyleOptions();
  const sendMessage = useSendMessage();
  const contextMenuItems = useContextMenu();
  const [{ SpeechRecognition = undefined } = {}] = useWebSpeechPonyfill();
  const [direction] = useDirection();
  const [disabled] = useDisabled();
  const [locale] = useLanguage();
  const [sendBoxValue, setSendBoxValue] = useSendBoxValue();
  const localize = useLocalizer();
  const druidLocalize = useDruidLocalize(localize);
  const focus = useFocus();
  const [speechInterimsVisible] = useSendBoxSpeechInterimsVisible();
  const styleToEmotionObject = useStyleToEmotionObject();
  const [activities] = useActivities();
  const lastActivity = useMemo(() => { return activities?.filter(act => act.type === 'message')?.slice(-1)[0]; }, [activities]);
  const lastBlockingInputActivity = useMemo(() => { return activities?.filter(act => act.type === 'message' && (act as any).inputHint === 'blockingInput')?.slice(-1)[0]; }, [activities]);
  const { wcRootRef } = useWebChatRefsContext();
  const activityRenderer =  useCreateActivityRenderer();
  const currentReplyToActivity = selectedActivityForReply?.id && activities.find(act => act.id === selectedActivityForReply.id);

  const transformedCurrentReplyToActivity = useMemo(() => {
    if(!currentReplyToActivity || !replyToMessageEnabled) {
      return null;
    }
    // const { attachments, ...restOfActivity } = currentReplyToActivity;
    const { ...restOfActivity } = currentReplyToActivity;

    const toReturnActivity = JSON.parse(JSON.stringify(restOfActivity));
    if(toReturnActivity.attachmentLayout === 'carousel') {
      toReturnActivity.attachments = null
    }
    toReturnActivity.channelData ||= {};
    toReturnActivity.channelData.replyActivityId = undefined
    toReturnActivity.channelData.isRepliedToActivity = true;
    toReturnActivity.text ||= "";
    toReturnActivity.text = toReturnActivity.text.substring(0, 200) + (toReturnActivity.text.length > 200 ? "..." : "");
    return toReturnActivity;
  }, [currentReplyToActivity?.id, replyToMessageEnabled])
  // const TEXT_INPUT_PLACEHOLDER_ref = useMemo<string>(() => localize("TEXT_INPUT_PLACEHOLDER"), [locale]); // keep original. do not change
  const [showSensitiveDataIcon, setShowSensitiveDataIcon] = useState(true);

  useLayoutEffect(() => {
    if (sendBoxTextWrap === false && sensitiveDataInputMode) {
      const inputElement = wcRootRef?.querySelector<HTMLInputElement>('.webchat__send-box-text-box__input');
      if (inputElement) {
        inputElement.type = showSensitiveDataIcon ? 'password' : 'text';
        inputElement.autocomplete = 'off'; // disable autocomplete
        inputElement.placeholder = druidLocalize("DRUID_TEXT_INPUT_PLACEHOLDER_SENSITIVE_DATA");
      }
    }

    return () => {
      if (sensitiveDataInputMode) { // hit when disabled 
      }
    }
  }, [wcRootRef, sendBoxTextWrap, sensitiveDataInputMode, showSensitiveDataIcon, locale, druidWebChatDispatch, druidLocalize, setShowSensitiveDataIcon]);

  useLayoutEffect(() => {
    if (inputBlocked) {
      const inputElement = wcRootRef?.querySelector<HTMLInputElement>('.webchat__send-box-text-box__input');
      if (inputElement) {
        inputElement.placeholder = druidLocalize("DRUID_TEXT_INPUT_PLACEHOLDER_SENSITIVE_DATA");
      }
    }
  }, [inputBlocked, druidLocalize, wcRootRef]);

  useLayoutEffect(() => { // change placeholder of sendbox. could change implementation someday and render only placeholder. please remove this
    if (lastActivity && shouldEnter_fileUploadInputMode(lastActivity)) {
      const inputElement = wcRootRef?.querySelector<HTMLInputElement>('.webchat__send-box-text-box__input, .webchat__send-box-text-box__html-text-area');
      if (inputElement) {
        inputElement.placeholder = druidLocalize("DRUID_FILEUPLOAD_INPUT_PLACEHOLDER_TEXT");
      }
      return () => {
        inputElement && (inputElement.placeholder = druidLocalize("TEXT_INPUT_PLACEHOLDER"));
      };
    }
  }, [lastActivity, druidLocalize, wcRootRef]);
  
  useEffect(() => {
    if (!sensitiveDataInputMode) {
      setShowSensitiveDataIcon(true);
    }
  }, [sensitiveDataInputMode, setShowSensitiveDataIcon])
  useEffect(() => {
    focus('sendBoxWithoutKeyboard');
  }, [sendBoxTextWrap, focus]);

  const ToggleSensitiveDataIcon = useMemo(() => showSensitiveDataIcon ? bsIcons["BsFillEyeSlashFill"] : bsIcons["BsFillEyeFill"], [showSensitiveDataIcon]);

  const ROOT_STYLE = {
    '&.webchat__send-box': {
        backgroundColor: backgroundColor,
        ...(replyToMessageEnabled && transformedCurrentReplyToActivity?.id && {
          backgroundColor: druidSendBoxReplyToModeBackgroundColor,
          borderTopLeftRadius: paddingRegular,
          borderTopRightRadius: paddingRegular,
        }),
        padding: `${druidSendBoxPaddingTop === 0 ? 0 : druidSendBoxPaddingTop || 0}px 
                  ${druidSendBoxPaddingLeftRight === 0 ? 0 : druidSendBoxPaddingLeftRight || (paddingRegular / 2)}px 
                  ${druidSendBoxPaddingBottom === 0 ? 0 : Math.max((druidSendBoxPaddingBottom || (paddingRegular / 2)) - (showPoweredBy ? 5 : 0), 0)}px 
                  ${druidSendBoxPaddingLeftRight === 0 ? 0 : druidSendBoxPaddingLeftRight || (paddingRegular / 2)}px`,
        fontSize: sendBoxFontSize,
        '& .webchat__send-box__button': { flexShrink: 0 },
        '& .webchat__send-box__dictation-interims': {
          flex: 10000,
          padding: druidSendBoxTextBoxPadding || (paddingRegular / 2),
          margin: 0
        },
        '& .webchat__send-box__main': {
          display: 'flex',
          borderRadius: druidSendBoxInnerBorderRadius === 0 ? 0 : druidSendBoxInnerBorderRadius || paddingRegular / 2,
          paddingTop: druidSendBoxInnerPaddingTopBottom,
          paddingBottom: druidSendBoxInnerPaddingTopBottom,
          paddingRight: druidSendBoxInnerPaddingLeftRight,
          paddingLeft: druidSendBoxInnerPaddingLeftRight
        },
        '& .webchat__send-box__microphone-button': { flex: 1 },
        '& .webchat__send-box__text-box': {
          // flex: 10000,
          // padding: druidSendBoxTextBoxPadding || (paddingRegular / 2),
          '& .webchat__send-box-text-box__input, & .webchat__send-box-text-box__html-text-area': { // sendbox textarea or input
            '&:disabled, &[aria-disabled="true"]': { // disabled
              '&::placeholder': {
                color: sendBoxDisabledTextColor || sendBoxButtonColorOnDisabled || subtle
              }
            }
          },
          '& + svg.webchat__send-box__toggle-show-sensitive-data': {
            float: 'right',
            position: 'relative',
            margin: 'auto',
            cursor: 'pointer',
            fill: sendBoxButtonColor || subtle
          },
          '&.webchat__send-box__text-box-blockingInput-placeholder': {
            color: subtle,
            textAlign: 'left',
            margin: 'auto'
          }
        },
        '& .druid__webchat__send-box__dropdown-menu': {
          display: 'flex',
          direction,
          ' > .dropdown-toggle': {
            color: sendBoxButtonColor || subtle,
            backgroundColor: 'transparent',
            border: 0,
            paddingRight: 0,
            cursor: 'pointer',
            ...(!restylingsEnabled && 
              {
                alignSelf: 'center'
              }
            ),
            ...(restylingsEnabled && 
              {
                alignSelf: sendBoxButtonAlignment === 'bottom' ? 'flex-end' : sendBoxButtonAlignment === 'top' ? 'flex-start' : 'center',
                color: subtle || sendBoxButtonColor,
                borderRadius: '50%',
                backgroundColor: sendBoxBackground,
                marginBlock: '5px',
                width: sendBoxHeight ? parseInt(sendBoxHeight.toString()) - 10 : sendBoxHeight,
                padding: 0,
                flexShrink: 0,
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                '&:focus-visible .webchat__icon-button__keyboard-focus-indicator': {
                    display: 'block !important'
                }
                // verticalAlign: 'unset'
                // '&:not(.webchat__icon-button--stretch)': {
                //     height: sendBoxHeight ? parseInt(sendBoxHeight.toString()) - 10 : sendBoxHeight
                // }
              }),
            // '&:hover:not([aria-disabled="true"]), &:focus:not([aria-disabled="true"])': {
            //   boxShadow: 'none',
            //   color: accent,
            //   ...(restylingsEnabled && 
            //     {
            //       // color: 'white',
            //       backgroundColor: sendBoxButtonShadeColor,
            //     }),
            // },
            '&:hover': {
              boxShadow: 'none',
              color: sendBoxButtonColorOnHover,
              ...(restylingsEnabled && 
                {
                  // color: 'white',
                  color: accent,
                  backgroundColor: sendBoxButtonShadeColor,
                }),
            },
            '&:focus': {
              boxShadow: 'none',
              color: sendBoxButtonColorOnFocus,
              ...(restylingsEnabled && 
                {
                  // color: 'white',
                  color: accent,
                  backgroundColor: sendBoxButtonShadeColor,
                }),
            },
            '&:focus-visible': {
              outline: 0,
            },
            '&[aria-disabled="true"]': {
              color: sendBoxButtonColorOnDisabled,
              ...(restylingsEnabled && {
                backgroundColor: sendBoxButtonShadeColorOnDisabled
              })
            },
            '&::after': {
              display: 'none'
            },
          },
          '& .dropdown-menu': {
            textAlign: direction === 'rtl' ? 'right' : 'left',
            ...(restylingsEnabled && 
              { padding: '0.5rem',
                marginBottom: 10,
                boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 6px',
                border: 'none',
              }),
            '.dropdown-item': {
              fontSize: sendBoxFontSize,
              '&:active': {
                backgroundColor: buttonsTextColor
              },
              ...(restylingsEnabled && 
                {
                  height: '3rem',
                  display: 'flex',
                  alignItems: 'center',
                  '&:hover, &:active': {
                    backgroundColor: sendBoxButtonShadeColor
                  }
              }),
            }
          },
        },
        '& .druid__webchat__send-box__emoji-picker': {
          '& .epr-main': {
            display: 'flex !important',
            '.epr-icn-suggested': {
              display: 'none'
            },
            '.epr-hidden-on-search': {
              display: 'none'
            },
            '.epr-emoji-category-label': {
              fontSize: '1rem !important',
              color: "var(--epr-category-label-text-color) !important",
            },
            '.epr-emoji-native': {
              fontFamily: 'Druid Twemoji !important',
              fontSize: '1.5rem !important'
            },
            '.epr-search-container': {
              '& > input': {
                color: 'var(--epr-text-color) !important'
              }
            }
          }
        },
        '& .webchat__bottom-banner': {
          'fontSize': fontSizeSmall, 
          display: 'flex', 
          'flexDirection': 'row-reverse', 
          justifyContent:'center', 
          color: subtle,
          '.webchat__bottom-banner__anchor': {
            'textDecoration': 'none', 
            color: accent,
            textTransform: 'uppercase', 
            marginLeft: 5
          }
        },
        '& .webchat__send-box__reply-to': {
          display: 'flex', 
          flexDirection: 'row', 
          flexGrow: 1, 
          backgroundColor: druidSendBoxReplyToModeBackgroundColor || sendBoxBackground, 
          paddingBlock: paddingRegular / 4, 
          marginBottom: 2,
          borderRadius: paddingRegular / 2,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          maxHeight: sendBoxMaxHeight,
          overflowY: 'auto',
          '& .druid_webchat_activity-wrapper': {
            marginTop: paddingRegular! / 2,
            '.webchat__stacked-layout__alignment-pad, .webchat__stacked-layout__avatar-gutter': {
              display: 'none',
            },
          },
          '&.webchat__send-box__reply-to-from-user': {
            flexDirection: 'row-reverse'
          },
          '&::-webkit-scrollbar': {
              width: 8
          },
          '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'rgb(219, 222, 225)',
              borderRadius: paddingRegular / 2
          },
          
          'button.druid__webchat__cancel-reply-button:hover':  {
                display: 'block !important'
          },
          'button.druid__webchat__cancel-reply-button': {
              alignSelf: 'center',
            // height: 20,
              position: 'absolute',
              right: paddingRegular,
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              width: paddingRegular,
              'svg': {
                width: '1.2rem',
                height: '1.2rem',
                fill: subtle,
              },
              '&:not([aria-disabled="true"]) svg:hover': {
                fill: accent
              },
          },
        }
     }
  };

  const rootClassName = styleToEmotionObject(ROOT_STYLE) + '';

  const supportSpeechRecognition = !!SpeechRecognition;

  const buttonClassName = classNames('webchat__send-box__button', {
    'webchat__send-box__button--align-bottom': sendBoxButtonAlignment === 'bottom',
    'webchat__send-box__button--align-stretch': sendBoxButtonAlignment !== 'bottom' && sendBoxButtonAlignment !== 'top',
    'webchat__send-box__button--align-top': sendBoxButtonAlignment === 'top'
  });

  const sendboxRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (sendboxRef.current) {
      sendboxRef.current?.querySelector('.webchat__upload-button--file-input')?.setAttribute('aria-label', druidLocalize('TEXT_INPUT_UPLOAD_BUTTON_ALT'))
    }
  }, [sendboxRef.current]);

  const sendBoxTemplate = useMemo(() => {

    const userInputEnabled = /*!blockingInputDruidSendBox &&*/ !inputBlocked;
    const uploadButtonTemplate = <>{( userInputEnabled && (shouldEnter_fileUploadInputMode(lastActivity) || !hideUploadButton)) && !sensitiveDataInputMode && <UploadButton className={buttonClassName} />}</>;

    // <EmojiPicker></EmojiPicker>

    const emojiPickerTemplate = <Dropdown className={"druid__webchat__send-box__dropdown-menu druid__webchat__send-box__emoji-picker"} role="menu" drop="up">
          <Dropdown.Toggle as={DruidEmojiToggle} disabled={disabled} >

          </Dropdown.Toggle>
          <Dropdown.Menu style={{padding: '0'}}>
            <EmojiPicker previewConfig={{showPreview: false}} skinTonesDisabled={true} emojiStyle={EmojiStyle.NATIVE} onEmojiClick={(emoji: EmojiClickData) => {
                const sendBoxValue = druidWebChatState?.store?.getState()?.sendBoxValue
                setSendBoxValue(sendBoxValue + emoji.emoji)
            }}></EmojiPicker>
          </Dropdown.Menu>
        </Dropdown>

    const [ firstAttachment ] = lastBlockingInputActivity?.type === 'message' &&  lastBlockingInputActivity?.attachments || [];
    const { contentType: lastBlockingInputActivity_attachmentType } = (firstAttachment || {});
    ///// !!!! Only default is used for now. could add different templates here, as shown below////
    // if (false && fileUploadInputMode) { 
    //   return (<>
    //     {
    //       uploadButtonTemplate
    //     }
    //     <div className="webchat__send-box__text-box webchat__send-box__text-box-blockingInput-placeholder">{druidLocalize('DRUID_FILEUPLOAD_INPUT_PLACEHOLDER_TEXT')}</div>
    //   </>);
    // }
    return (<>
      { userInputEnabled && contextMenuItems && contextMenuItems.length > 0 &&

        <Dropdown className={"druid__webchat__send-box__dropdown-menu"} role="menu" drop="up">
          <Dropdown.Toggle as={DruidDropdownToggle} disabled={disabled} >

          </Dropdown.Toggle>
          <Dropdown.Menu>
            {
              contextMenuItems.map((cmi, idx) => {

                return (<React.Fragment key={`${cmi}_${idx}`} >
                  <Dropdown.Item role="menuitem" href={void (0)} onClick={() => sendMessage(cmi)}>{cmi}</Dropdown.Item>
                  { !restylingsEnabled && idx + 1 < contextMenuItems.length && <Dropdown.Divider />}
                </React.Fragment>)
              })
            }
          </Dropdown.Menu>
        </Dropdown>

      }
      {uploadButtonTemplate}
      {emojiPickerEnabled && userInputEnabled && emojiPickerTemplate}
      { userInputEnabled && (speechInterimsVisible ? (
        <DictationInterims className="webchat__send-box__dictation-interims" />
      ) : (
        <>
          <SendTextBox className="webchat__send-box__text-box" />
          {sensitiveDataInputMode && <ToggleSensitiveDataIcon size={16} className="webchat__send-box__toggle-show-sensitive-data" onClick={() => setShowSensitiveDataIcon(!showSensitiveDataIcon)} />}
          {/* { sensitiveDataInputMode && <HideSensitiveDataIcon size={16} className="webchat__send-box__toggle-show-sensitive-data"/> } */}
        </>
      ))}
      { userInputEnabled && (supportSpeechRecognition ? (
        <MicrophoneButton className={classNames(buttonClassName, 'webchat__send-box__microphone-button')} />
      ) : (
        <SendButton className={buttonClassName} />
      ))}
      { !userInputEnabled && <div className="webchat__send-box__text-box webchat__send-box__text-box-blockingInput-placeholder" tabIndex={-1} aria-disabled="true">{ lastBlockingInputActivity_attachmentType === 'application/vnd.microsoft.card.adaptive' ? druidLocalize('DRUID_BLOCKING_INPUT_AC_PLACEHOLDER_TEXT') : druidLocalize('DRUID_BLOCKING_INPUT_PLACEHOLDER_TEXT')}</div>}
    </>)
  }, [lastActivity, lastBlockingInputActivity, blockingInputDruidSendBox, hideUploadButton, sensitiveDataInputMode, buttonClassName, fileUploadInputMode, contextMenuItems, disabled, speechInterimsVisible, ToggleSensitiveDataIcon, supportSpeechRecognition, druidLocalize, sendMessage, showSensitiveDataIcon, inputBlocked, selectedActivityForReply]);

  return (
    !hideDruidSendBox &&
    <div
      className={classNames('webchat__send-box', sendBoxStyleSet + '', rootClassName + '', (className || '') + '')}
      dir={direction}
      role="form"
    >

      {!hideSuggestedActions && <SuggestedActions />}
      {
        transformedCurrentReplyToActivity?.id && <div className={classNames({
          'webchat__send-box__reply-to': true,
          'webchat__send-box__reply-to-from-user': transformedCurrentReplyToActivity?.from?.role !== 'bot'
          })}>
          { (activityRenderer({ activity: transformedCurrentReplyToActivity, nextVisibleActivity: {} as any }) as any)?.()}
          <div style={{flexGrow: 1}}></div>
          <button className="druid__webchat__cancel-reply-button"
              aria-disabled={false} onClick={() => {druidWebChatDispatch({ type: 'SET_SELECTEDACTIVITY_FOR_REPLY', payload: { activity: null }})}} title={'Remove'}>
                <FaRegTimesCircle></FaRegTimesCircle>
              </button>
        </div>
      }
      <div className="webchat__send-box__main" ref={sendboxRef}>
        {sendBoxTemplate}
      </div>
      {
       showPoweredBy && 
            <div className="webchat__bottom-banner">
               <span className="webchat__bottom-banner__label"> 
                    Powered by 
                    <a href={"https://druidai.com"} target='blank' className="webchat__bottom-banner__anchor" aria-label="Powered by Druid">Druid</a>
                </span>
            </div> 
        }

    </div>
  );
});

DruidSendBox.defaultProps = {
  className: ''
};

DruidSendBox.propTypes = {
  className: PropTypes.string
};

const DruidDropdownToggle: FC<any> = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { children, onClick, className, disabled} = props;
  const expanded = props["aria-expanded"] as boolean;
  const { UI: { v2_contextMenu_icon = "", restylingsEnabled } = {}} = useMergedOptions();
  const druidLocalize = useDruidLocalize();
  const [{ sendBoxButton: sendBoxButtonStyleSet }] = useStyleSet();
  // const localUseClick = useCallback((e) => onClick ? onClick(e) : (e) => { e.preventDefault()}, [onClick]);
  // const DDIcon = faIcons[contextMenuIcon] || faIcons[webChatDefaultOptions.UI?.contextMenuIcon!];

  return (
    <button
      disabled={disabled}
      aria-disabled={disabled}
      className={classNames(sendBoxButtonStyleSet + '', className, 'webchat__icon-button')}
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick && onClick(e);
      }}
      title={druidLocalize("DRUID_CONTEXTUAL_MENU_BUTTON_ALT")}
    >
      {<InlineSVG src={typeof v2_contextMenu_icon === "function" ? v2_contextMenu_icon({ size: 24 }) : (v2_contextMenu_icon || defaultContextMenuIcon({ size: 24, restylingsEnabled, expanded }))} raw={true}></InlineSVG>}
      <div className={"webchat__icon-button__keyboard-focus-indicator"}></div>
    </button>
  );
});

const DruidEmojiToggle: FC<any> = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { children, onClick, className, disabled} = props;
  const expanded = props["aria-expanded"] as boolean;
  const { UI: {  restylingsEnabled } = {}} = useMergedOptions();
  const druidLocalize = useDruidLocalize();
  const [{ sendBoxButton: sendBoxButtonStyleSet }] = useStyleSet();

  return (
    <button
      disabled={disabled}
      aria-disabled={disabled}
      className={classNames(sendBoxButtonStyleSet + '', className, 'webchat__icon-button')}
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick && onClick(e);
      }}
      title={druidLocalize("DRUID_EMOJI_PICKER_BUTTON_ALT")}
    >
      {/* {<InlineSVG src={defaultContextMenuIcon({ size: 24, restylingsEnabled, expanded })} raw={true}></InlineSVG>} */}
      <BsEmojiSmile size={24}></BsEmojiSmile>
      <div className={"webchat__icon-button__keyboard-focus-indicator"}></div>
    </button>
  );
});


export default DruidSendBox;

export { useSendBoxSpeechInterimsVisible };
